<div class="apg-loading" *ngIf="loading">
  <p>{{message}}</p>
  <ion-spinner></ion-spinner>
</div>

<div class="quick-quote-verify-otp" *ngIf="!loading">
  <div class="title" *ngIf="title">{{title}}</div>
  <div [ngSwitch]="true">
    <div class="quick-quote-verify-otp__email" *ngSwitchCase="preferredChannel == 'Email'">
      <div class="email__label">
        <ion-label>Please verify your email address</ion-label>
      </div>
      <div class="input-group">
        <input type="email" [(ngModel)]="email" class="form-control type_msg" placeholder="Email"
               [class.has-error]="error" [class.is-invalid]="error" required (blur)="validateEmail()" />
      </div>
      <p>We will send an One Time Passcode to verify your email address.</p>
    </div>

    <div class="quick-quote-verify-otp__email" *ngSwitchCase="preferredChannel == 'Sms' || preferredChannel == 'Call'">
      <div class="email__label">
        <ion-label>Please verify your phone number</ion-label>
      </div>
      <div class="input-group">
        <input type="mobile" [(ngModel)]="mobile" class="form-control type_msg" placeholder="Mobile"
               [class.has-error]="error" [class.is-invalid]="error" required (blur)="validateMobile()" />
      </div>
      <p>We will send an One Time Passcode to verify your phone number.</p>
    </div>

  </div>

  <div class="invalid-feedback d-block" *ngIf="!!error">
    {{error}}
  </div>

  <div class="summary__buttons" buttons>
    <ion-button (click)="onPrev()">
      <ion-icon name="chevron-back-outline"></ion-icon>
      Previous
    </ion-button>

    <ion-button (click)="onNext()" [disabled]="!email && !mobile">
      Next
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>